import { Tab, Tabs, useTheme } from "@mui/material"
import { DetailsSelection, DetailsTabType } from "../JobDetails"

import { ReactComponent as DetailsIcon } from '../../../../assets/Icons/adornments/Alert-Triangle.svg';
import { ReactComponent as MetadataIcon } from '../../../../assets/Icons/adornments/Info.svg';
import { ReactComponent as MappedTasksIcon } from '../../../../assets/Icons/adornments/Brackets.svg';
import { ReactComponent as LogsIcon } from '../../../../assets/Icons/adornments/Code.svg';
import { ReactElement, useEffect, useState } from "react";

const displayLogs = (selection: DetailsSelection) => {
  let showLogs = false;
  if (selection.logs) {
      const logs = selection.logs;

      if (logs.return_value && typeof logs.return_value === 'string') {
        showLogs = true;
      } else if (logs.result) {
        const result = logs.result;

        if (result.docker_stderr_logs && typeof result.docker_stderr_logs === 'string') {
          showLogs = true;
        }
      }
  }

  return showLogs;
}

export default function DetailsTabs({
    selection,
    handleTabChange,
    tab,
}: {
    selection: DetailsSelection,
    handleTabChange: (event: React.SyntheticEvent, newValue: DetailsTabType) => void,
    tab: DetailsTabType,
}) {
    const theme = useTheme();
    const [ tabs, setTabs ] = useState<{
        label: string,
        icon: ReactElement,
        value: string,
    }[]>([]);

    useEffect(() => {
        let detailTabs: {
            label: string,
            icon: ReactElement,
            value: string,
        }[] = [
            {
                label: 'Details',
                icon: (
                    <div className="w-[14px]">
                        <DetailsIcon />
                    </div>
                ),
                value: 'details'
            }
        ];

        if (selection.metadata) {
            detailTabs.push({
                label: 'Metadata',
                icon: (
                    <div className="w-[14px]">
                        <MetadataIcon />
                    </div>
                ),
                value: 'metadata'
            })
        };

        if (selection.mapped_tasks) {
            detailTabs.push({
                label: 'Mapped Tasks',
                icon: (
                    <div className="w-[14px]">
                        <MappedTasksIcon />
                    </div>
                ),
                value: 'mapped_tasks',
            })
        };

        if (displayLogs(selection)) {
            detailTabs.push({
                label: 'Logs',
                icon: (
                    <div className="w-[14px]">
                        <LogsIcon />
                    </div>
                ),
                value: 'logs'
            })
        }

        setTabs(detailTabs);

    }, [selection]);

    return (
       <div className="w-full border-b border-outline">
            <Tabs 
                value={tab} 
                onChange={handleTabChange}
                sx={{
                    minHeight: 0,

                    '& .MuiTabs-indicator': {
                        backgroundColor: theme.palette.primary.main,
                    }
                }}
            >
                {tabs.length > 0 && tabs.map(tab => (
                    <Tab 
                        label={tab.label}
                        icon={tab.icon}
                        iconPosition="start" 
                        value={tab.value}
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignContent: 'center',
                            gap: '2px',
                            lineHeight: 1,
                            fontSize: '14px',
                            minHeight: 0,
                            padding: '16px',

                            '&.Mui-selected': {
                                color: theme.palette.primary.main,
                            }
                        }}
                    />
                ))}
            </Tabs>
       </div>
    )
}